import { createContext, useContext } from 'react';

export const AuthContext = createContext(null);

export const useAuthContext = () => {
  const context = useContext(AuthContext);
  if (!context) throw new Error('useAuthContext: must be called inside AuthContext.Provider');
  return context;
};
